'use strict';
class PagoRechazoModalController {
  constructor($uibModalInstance, data, $sce, $log, DataService, Message, $state, $location) {
    'ngInject';
    this.data = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$sce = $sce;
    this.$log = $log;
    this.DataService = DataService;
    this.$state = $state;
    this.$location = $location;
    this.Message = Message;
  }

  $onInit() {
  }

  ok() {
    const dataRequest = {
      id_pago: this.data.id_pago,
      id_certificacion: this.data.id_certificacion,
      observacion: this.observacion
    };

    const ruta = 'certificacion_promueve/pagos/rechazar';
    this.DataService.put(ruta, dataRequest)
      .then(response => {
        if (response) {
          this.$uibModalInstance.close();
          this.Message.success('El rechazo de la certificación se ha procesado satisfactoriamente', 'Notificación');
          this.$location.path('certificaciones');
        }
    });

    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default PagoRechazoModalController;


// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/impresion/modal_input/pagorechazo.modal.obs.controller.js